document.addEventListener('DOMContentLoaded', function () {
    const alphabetBtns = document.querySelectorAll('.alphabet-btn');
    const vendorGroups = document.querySelectorAll('.vendor-group');
    const vendorsSection = document.querySelector('.vendors-section');

    // Smooth scroll function
    function smoothScrollTo(element) {
        const offsetTop = element.offsetTop + 500;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }

    // Handle alphabet button clicks
    alphabetBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const letter = this.dataset.letter;
            const targetGroup = document.getElementById('letter-' + letter);

            // Remove active class from all buttons
            alphabetBtns.forEach(function (b) {
                b.classList.remove('active');
            });

            // Add active class to clicked button
            this.classList.add('active');

            // Remove highlight from all groups
            vendorGroups.forEach(function (group) {
                group.classList.remove('highlight');
            });

            if (targetGroup) {
                // Scroll to target group
                smoothScrollTo(targetGroup);

                // Add highlight after scroll
                setTimeout(function () {
                    targetGroup.classList.add('highlight');

                    // Remove highlight after animation
                    setTimeout(function () {
                        targetGroup.classList.remove('highlight');
                    }, 1000);
                }, 300);
            }
        });
    });

    // Intersection Observer for automatic active state
    const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                const letter = entry.target.dataset.letter;
                const correspondingBtn = document.querySelector('.alphabet-btn[data-letter="' + letter + '"]');

                // Remove active class from all buttons
                alphabetBtns.forEach(function (btn) {
                    btn.classList.remove('active');
                });

                // Add active class to corresponding button
                if (correspondingBtn) {
                    correspondingBtn.classList.add('active');
                }
            }
        });
    }, observerOptions);

    // Observe all vendor groups
    vendorGroups.forEach(function (group) {
        observer.observe(group);
    });

    // Add smooth reveal animation on scroll
    const revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, {
        threshold: 0.1
    });

    vendorGroups.forEach(function (group) {
        revealObserver.observe(group);
    });
});